module.exports = __webpack_public_path__ + "static/media/TFUEL.2e58e3f3.svg";